import { i18n } from '../../../vue-i18n';

export default class DeactivateEvent {
  constructor(eventIds) {
    this.commandName = 'DeactivateEvent';
    this.eventIds = eventIds;

    this.description = `${i18n.t('CONTENT.events.DeactivateEvent')}`;
  }

  serialize() {
    const serialisedCommand = JSON.stringify({
      eventIds: this.eventIds,
    });

    return {
      commandName: this.commandName,
      serialisedCommand,
    };
  }

  equal() {
    return false;
  }
}
